const ICON_FILTER = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-funnel mr-2" viewBox="0 0 16 16"><path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .39.812L10 7.118V13.5a.5.5 0 0 1-.757.429l-2.5-1.5A.5.5 0 0 1 6.5 12.5V7.118L1.61 1.812A.5.5 0 0 1 1.5 1.5z"/></svg>';
const ICON_UP = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 10.354a.5.5 0 0 0 .708 0L8 4.707l5.646 5.647a.5.5 0 0 0 .708-.708l-6-6-6 6a.5.5 0 0 0 0 .708z"/></svg>';
const ICON_DOWN = '<svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6-6-6a.5.5 0 0 1 0-.708z"/></svg>';

function createToggleButton(title) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2';
  button.innerHTML = `<span class="d-flex align-items-center">${ICON_FILTER}<span>${title}</span></span><span class="lg-filter-toggle__icon">${ICON_UP}</span>`;
  return button;
}

class FilterCollapseManager {
  constructor() {
    this.title = 'Filtros';
  }

  init(root) {
    if (!root || !(root instanceof Element)) return;
    const cardBodies = root.querySelectorAll('.card-body');
    cardBodies.forEach((body) => {
      const targetCard = this.findFilterCard(body);
      if (targetCard) {
        this.processCard(targetCard);
      }
    });
  }

  findFilterCard(container) {
    const cards = Array.from(container.children).filter((el) => el.classList && el.classList.contains('card'));
    for (const card of cards) {
      if (card.hasAttribute('data-manual-filter')) continue;
      if (!card.classList.contains('bg-light')) continue;
      if (card.querySelector('.collapse')) continue; // já possui comportamento próprio
      const hasInput = card.querySelector('input, select, textarea, [contenteditable="true"]');
      if (!hasInput) continue;
      const hasFilterAction = card.querySelector('button[id*="limpar" i], button[id*="localiza" i], button[id*="buscar" i], button[id*="pesquisar" i], button[id*="busca" i]');
      if (!hasFilterAction) continue;
      return card;
    }
    return null;
  }

  processCard(card) {
    const cardBody = card.querySelector(':scope > .card-body');
    if (!cardBody) return;

    let filterContainer = cardBody.querySelector(':scope > .lg-filter-container');
    const hasContainer = !!filterContainer;
    if (!filterContainer) {
      filterContainer = document.createElement('div');
      filterContainer.className = 'lg-filter-container';
      cardBody.insertBefore(filterContainer, cardBody.firstChild);
    }

    const toggleSelector = ':scope > .lg-filter-toggle';
    let toggleButton = cardBody.querySelector(toggleSelector);
    if (!toggleButton) {
      toggleButton = createToggleButton(this.title);
      cardBody.insertBefore(toggleButton, filterContainer);
    }

    const state = toggleButton.__lgFilterState || {
      isOpen: true,
      iconContainer: toggleButton.querySelector('.lg-filter-toggle__icon'),
    };
    state.container = filterContainer;
    state.cardBody = cardBody;

    if (!toggleButton.__lgFilterState) {
      toggleButton.__lgFilterState = state;
      toggleButton.addEventListener('click', () => {
        state.isOpen = !state.isOpen;
        this.updateState(state);
      });
    }

    // Move filter nodes (elements between container and first result section)
    let node = filterContainer.nextElementSibling;
    while (node) {
      if (this.isResultSection(node)) break;
      const next = node.nextElementSibling;
      filterContainer.appendChild(node);
      node = next;
    }

    // If container already existed, capture any elements inserted before it
    if (hasContainer) {
      let previous = filterContainer.previousElementSibling;
      while (previous && previous !== toggleButton) {
        if (this.isResultSection(previous)) break;
        const nextPrev = previous.previousElementSibling;
        filterContainer.insertBefore(previous, filterContainer.firstChild);
        previous = nextPrev;
      }
    }

    // Remove container if empty (no filters)
    if (!filterContainer.childElementCount) {
      filterContainer.remove();
      if (toggleButton.parentNode === cardBody) {
        toggleButton.remove();
      }
      return;
    }

    this.updateState(state);
  }

  isResultSection(node) {
    if (!node) return true;
    if (node.matches('.lg-filter-container')) return true;
    if (node.matches('.lg-filter-toggle')) return false;
    if (node.matches('.table, table, .b-table, .lg-filter-results, .table-responsive, .lg-status-card, lg-status-card')) return true;
    if (node.querySelector && node.querySelector('.table, table, .b-table, .table-responsive, .lg-status-card, lg-status-card')) return true;
    return false;
  }

  updateState(state) {
    const { container, iconContainer, cardBody, isOpen } = state;
    if (!container || !iconContainer || !cardBody) return;
    if (isOpen) {
      container.style.display = '';
      iconContainer.innerHTML = ICON_UP;
      cardBody.classList.remove('lg-filter-collapsed');
    } else {
      container.style.display = 'none';
      iconContainer.innerHTML = ICON_DOWN;
      cardBody.classList.add('lg-filter-collapsed');
    }
  }
}

const manager = new FilterCollapseManager();

export default {
  install(Vue) {
    Vue.mixin({
      mounted() {
        this.$nextTick(() => {
          manager.init(this.$el);
        });
      },
      updated() {
        this.$nextTick(() => {
          manager.init(this.$el);
        });
      },
    });
  },
};

